import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {map} from 'rxjs/operators';
import {environment as env} from '../../environments/environment';
import{Category} from '../models/category';

@Injectable({providedIn: 'root'})
export class ProductsService {
  imgsUrl:string;
  restsList:any = [];
  prodIdAr:string;
  varvalid = new EventEmitter<any[]>();

  ingrdAr = new EventEmitter<any[]>();
  adoncartArr = new EventEmitter<any[]>();
  verientcartArr = new EventEmitter<any[]>();
  ingcartArr = new EventEmitter<any[]>();
  varientqtyArr = new EventEmitter<any[]>();


  constructor(private http:HttpClient){}

  getallcats(){
    return this.http.get(env.apiurl+'getallcats')
    .pipe(map(respData => {return respData;})
    );
  }

  getProductsBySlug(catslug:string){ 
    var uid = localStorage.getItem("sajid");
    if(uid != null && uid != undefined){
      uid = uid;
    }
    return this.http.get(env.apiurl+'get-prod-by-cat-slug/'+catslug+'?userid='+uid)
    .pipe(map(rawData => {return rawData;})); 
  }
  
  getProductSlug(pslug:string, cslug:string){
    var uid = localStorage.getItem("sajid");
    if(uid != null && uid != undefined){
      uid = uid;
    }
    let params = new HttpParams().set('catslug', cslug);
    return this.http.get(env.apiurl+'get-prod-by-slug/'+pslug+'?userid='+uid, {params})
    .pipe(map(rawData => {return rawData;}));  
  }
  
}